import { render, staticRenderFns } from "./BasketTable.vue?vue&type=template&id=ea9e9f22"
import script from "./BasketTable.ts?vue&type=script&lang=ts&external"
export * from "./BasketTable.ts?vue&type=script&lang=ts&external"
import style0 from "./BasketTable.vue?vue&type=style&index=0&id=ea9e9f22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCheckbox,VDataTable,VIcon})
